import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Recipe from 'Recipe'

class Home extends Component {
  constructor (props) {
    super(props)
    this.state = {
      recipes: [
        { day: 'Måndag',
          seed: Math.floor(Math.random() * 50000)
        }, {
          day: 'Tisdag',
          seed: Math.floor(Math.random() * 50000)
        }, {
          day: 'Onsdag',
          seed: Math.floor(Math.random() * 50000)
        }, {
          day: 'Torsdag',
          seed: Math.floor(Math.random() * 50000)
        }, {
          day: 'Fredag',
          seed: Math.floor(Math.random() * 50000)
        }
      ]
    }
  }
  componentWillMount () {
    this.setState({
      recipes: this.state.recipes.map(recipe => {
        return {
          day: recipe.day,
          title: new Recipe(recipe.seed).recipeObj.title,
          seed: recipe.seed
        }
      })
    })
  }
  render () {
    return (
      <div>
        <h1>En rätt dum matkasse</h1>
        <h2>Veckans recept</h2>
        <ul className='Recipes'>
          { this.state.recipes.map(recipe => (
            <li key={recipe.seed}>
              <Link to={recipe.seed.toString()}>
                <span className='Recipes-day'>{recipe.day}</span>{ recipe.title }
                <span className='Recipes-button'>Visa recept</span>
              </Link>
            </li>
        ))}
        </ul>
      </div>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/containers/Home/index.js